import { styled } from 'styled-components'

import { COLORS } from 'consts/colors'
import { Button } from 'common-components'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: clamp(280px, 50vw, 400px);
  gap: 32px;
  max-width: 90%;
  margin: auto;
`

export const Image = styled.img`
  width: auto;
  height: 100px;
`

export const Title = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: ${COLORS.secondaryExtraDark};
  margin-bottom: 8px;
  text-align: center;
`

export const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: ${COLORS.secondarySemiDark};
`

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;

  /* Stack full-width on mobile (primary on top) so long per-locale labels
     don't wrap inside a squeezed side-by-side row. */
  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    flex-direction: column-reverse;
    align-self: stretch;
    gap: 12px;

    button {
      width: 100%;
    }
  }
`

export const ActionButton = styled(Button)`
  @media (min-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    width: 190px;
    padding: 8px 14px;
    height: 40px;
  }
`

export const ConfirmationTitle = styled.div``

export const ConfirmationDescription = styled.div`
  margin-bottom: 24px;

  .confirmation-description {
    margin: 0;
  }
`
